var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.votingLink)?_c('div',{staticClass:"floating-vote-now"},[_c('a',{attrs:{"href":_vm.project.voting_link,"target":"_blank"}},[_c('img',{attrs:{"src":"/static/images/mobile-vote-now.png","alt":"Vote Now!"}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97f6fc74","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VoteNowFixed.vue
// module id = null
// module chunks = 